var map = {
	"./demos/animate/index.ts": 56866,
	"./demos/avator/index.ts": 51902,
	"./demos/basic/index.ts": 54170,
	"./demos/custom/index.ts": 85326,
	"./demos/rows/index.ts": 94746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94798;